import { useLayoutEffect, useRef, useEffect } from "react";
import SVG from "react-inlinesvg";

export default function ElectionsTabs({
  menuList = [],
  currentPath = "",
  electionPassedCategory,
}) {
  const containerRef = useRef(null);
  const itemRefs = useRef([]);
  const roRef = useRef(null);

  useEffect(() => {
    itemRefs.current = [];
  }, [menuList]);

  const centerSelected = (selectedIndex) => {
    const container = containerRef.current;
    const el = itemRefs.current[selectedIndex];
    if (!container || !el) return;

    const containerRect = container.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();

    const elOffsetLeftRelativeToContainer =
      elRect.left - containerRect.left + container.scrollLeft;

    const targetScroll =
      elOffsetLeftRelativeToContainer -
      (container.clientWidth / 2 - elRect.width / 2);

    const maxScroll = container.scrollWidth - container.clientWidth;
    const clamped = Math.max(0, Math.min(targetScroll, Math.max(0, maxScroll)));

    container.scrollTo({ left: clamped, behavior: "smooth" });
  };

  useLayoutEffect(() => {
    if (!menuList?.length) return;

    const selectedIndex = menuList.findIndex((m) => {
      const pathA = `/elections/${m?.slug}`;
      const isConstituencySpecial =
        currentPath.includes("-assembly-constituency-result-") &&
        m?.slug === `${electionPassedCategory}/constituency-list`;
      return currentPath === pathA || isConstituencySpecial;
    });

    if (selectedIndex === -1) return;

    centerSelected(selectedIndex);

    const id = setTimeout(() => centerSelected(selectedIndex), 80);

    const container = containerRef.current;
    if (container && typeof ResizeObserver !== "undefined") {
      roRef.current = new ResizeObserver(() => centerSelected(selectedIndex));
      roRef.current.observe(container);

      itemRefs.current.forEach((it) => it && roRef.current.observe(it));
    }

    return () => {
      clearTimeout(id);
      if (roRef.current) {
        try {
          roRef.current.disconnect();
        } catch (e) {}
        roRef.current = null;
      }
    };
  }, [currentPath, menuList, electionPassedCategory]);

  return (
    <div
      ref={containerRef}
      className="flex gap-3 flex-row overflow-x-auto scrollbar-hide mt-2 mx-4 md:mx-4 scroll-smooth"
      style={{ WebkitOverflowScrolling: "touch" }}
      role="tablist"
      aria-label="Elections tabs"
    >
      {menuList?.map((item, index) => {
        const isSelected =
          currentPath === `/elections/${item?.slug}` ||
          (currentPath.includes("-assembly-constituency-result-") &&
            item?.slug === `${electionPassedCategory}/constituency-list`);

        return (
          <a
            key={item?.slug || index}
            ref={(el) => (itemRefs.current[index] = el)}
            href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}/elections/${item?.slug}`}
            className={`${
              isSelected
                ? "bg-[#CF4C9B] text-white border-2 border-[#CF4C9B]"
                : "border-2 text-gray-600 hover:text-[#CF4C9B]"
            } px-3 py-1 rounded-xl whitespace-nowrap flex flex-row items-center gap-1 justify-center`}
            role="tab"
            aria-selected={isSelected ? "true" : "false"}
          >
            <div style={{ minWidth: "1rem" }}>
              {[
                "/assets/liveIcon.gif",
                "/assets/i6.gif",
                "/assets/i4.gif",
                "/assets/icons/svg/chunavSeat.svg",
                "/assets/icons/svg/constiseat.svg"
              ].some((icon) => item?.src?.includes(icon)) ? (
                <img
                  className="h-4 w-4"
                 src={
    
    (currentPath?.includes("-assembly-constituency-result-") ||
      currentPath?.includes("constituency-list")) &&
    item?.slug == `${electionPassedCategory}/constituency-list`
      ?isSelected ? "/assets/icons/svg/constiseat.svg"
      : "/assets/icons/svg/chunavSeat.svg" :  item?.src
  }
                  alt=""
                />
              ) : (
                <SVG className="h-4 w-4" src={item?.src} />
              )}
            </div>
            <p>{item?.title}</p>
          </a>
        );
      })}
    </div>
  );
}
